import { type Common } from '../common.js';
import {
  type FlowRunAnalyticEvent,
  type FlowRunAnalyticEventFindAllOptions,
} from '../models/flow/flowRunAnalyticEvent.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/flow-run-analytic-events';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(queryParams?: FlowRunAnalyticEventFindAllOptions): Promise<FlowRunAnalyticEvent[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }
}
